import { ButtonBase, styled } from '@mui/material';

export const BackButton = styled(ButtonBase)(({ theme }) => ({
	marginBottom: theme.spacing(2),
	'& svg path': {
		fill: theme.palette.text.primary,
	},
}));
